import { FC, useCallback, useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import { PASSWORD_MAX_LENGTH } from '@loomstateorg/shared-frontend/hooks/useValidate';
import Input, { InputProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/input';

export interface PasswordInputProps extends InputProps {
  toggleClassName?: string;
}

const PasswordInput: FC<PasswordInputProps> = ({ toggleClassName = 'top-20', ...props }) => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const [hidden, setHidden] = useState<boolean>(true);

  const toggleHidden = useCallback(() => setHidden((isHidden) => !isHidden), []);

  const iconsClassName = 'w-15 h-15';

  const toggleClassNames = useClassNames([
    'absolute right-12 z-10 flex translate-y-[-50%] items-center hover:cursor-pointer',
    toggleClassName,
  ]);

  return (
    <div className="relative" data-testid="atom-input-password">
      <Input type={hidden ? 'password' : 'text'} hideCheckIcon maxLength={PASSWORD_MAX_LENGTH} {...props}>
        <button
          type="button"
          onClick={toggleHidden}
          className={toggleClassNames}
          aria-label={
            hidden
              ? formatAccountMessage({ id: 'password.show', defaultMessage: 'Show password' })
              : formatAccountMessage({ id: 'password.hide', defaultMessage: 'Hide password' })
          }
          data-testid={`${props.id ?? props.name ?? 'password'}-visibility-toggle`}
        >
          {hidden ? (
            <EyeSlashIcon className={iconsClassName} aria-hidden="true" />
          ) : (
            <EyeIcon className={iconsClassName} aria-hidden="true" />
          )}
        </button>
      </Input>
    </div>
  );
};

export default PasswordInput;
